import { BaseEntity } from '@bndes/bndes-ux4/bndes-angular-utils';
import { JanelaEnvioProtocolo } from './protocolo-arquivo.model';

export class JanelaSolicitacaoHonra extends JanelaEnvioProtocolo {

	public usuarioAprovacaoContasSap: string;

}

export class JanelaSolicitacaoHonraEnvio{
	public idJanela?: number;
 	public nomeJanela?: string;
 	public pagina: number;
 	public limite: number;
}

export class JanelaSolicitacaoHonraResposta extends BaseEntity{
	public dataAbertura: string;
  public dataFechamento: string;
  public dataInicioProcessamento: string;
  public nomeJanela: string;
 	public usuarioAprovacaoContasSap: string;
}